const {
  createMapEntry,
  join,
  path,
  pick,
} = require('ramda')
const httpFuture = require('./http-future')

const self = {}
const buildURI = join('/')
const getSubscription = path([ 'body', 'subscription' ])
const getSubscriptions = path([ 'body', 'subscriptions' ])
const getSubscriptionProducts = path([ 'body', 'subscriptionProducts' ])
const getSubscriptionProduct = path([ 'body', 'subscriptionProduct' ])

self.getForOwner = function (ownerId) {
  const uri = buildURI([ '/subscriptionowners', ownerId, 'subscription' ])
  return httpFuture.get(uri).map(getSubscription)
}

self.getPartnerSubscriptions = function (orgId) {
  const uri = buildURI([ '/organizations', orgId, 'partnersubscriptions' ])
  return httpFuture.get(uri).map(path([ 'body', 'subscriptions' ]))
}

self.cancel = function (ownerId) {
  const uri = buildURI([ '/subscriptions', ownerId, 'cancel' ])
  return httpFuture.post(uri).map(getSubscription)
}

self.purchase = function (payer, planId) {
  const uri = buildURI([ '/subscriptions', payer._id, 'purchase' ])
  const payerInfo = pick([ 'vatNumber', 'isOutsideEU' ], payer)
  const body = { payerInfo, subscription: { planId } }
  return httpFuture.postWithData(uri, body).map(getSubscription)
}

self.getCreditCards = function (payerId) {
  const uri = buildURI([ '/payers', payerId, 'creditcards' ])
  return httpFuture.get(uri).map(path([ 'body', 'creditCards' ]))
}

self.createCreditCard = function (payerId, paymentMethodNonce) {
  const uri = '/creditcards'
  const body = {
    creditCard: {
      payerId,
      paymentMethodNonce,
    },
  }
  return httpFuture.postWithData(uri, body).map(path([ 'body', 'creditCard' ]))
}

self.purchaseAll = function (payer, upgrades) {
  const uri = buildURI([ '/subscriptions', payer._id, 'partnersubscriptions' ])
  const payerInfo = pick([ 'isOutsideEU', 'vatNumber' ], payer)
  const body = { payerInfo, upgrades }
  return httpFuture.postWithData(uri, body)
}

self.getTransactions = function (payerId) {
  const uri = buildURI([ '/subscriptionpayers', payerId, 'transactions' ])
  return httpFuture.get(uri).map(path([ 'body', 'transactions' ]))
}

self.searchTransactions = function (query) {
  const q = JSON.stringify(query)
  return httpFuture.getWithQuery('/transactions', { q }).map(path([ 'body', 'transactions' ]))
}

self.deleteCard = function (cardId) {
  return httpFuture.del(`/creditcards/${cardId}`)
}

self.setActiveCard = function (payerId, cardId) {
  const uri = buildURI([ '/payers', payerId, 'defaultcreditcard' ])
  const body = createMapEntry('creditCard', cardId)
  return httpFuture.putWithData(uri, body).map(path([ 'body', 'creditCard' ]))
}

self.prolong = function (ownerId, endDate) {
  const uri = buildURI([ '/subscriptions', ownerId, 'trialenddate' ])
  const body = createMapEntry('endDate', endDate)
  return httpFuture.putWithData(uri, body).map(getSubscription)
}

self.setPaymentMethod = function (orgId, paymentMethod) {
  const uri = buildURI([ '/subscriptions', orgId, 'paymentmethod' ])
  const data = { paymentMethod }
  return httpFuture.putWithData(uri, data).map(getSubscription)
}

self.getStats = function () {
  const uri = '/subscriptionstats'
  return httpFuture.get(uri).map(path([ 'body', 'subscriptionstats' ]))
}

self.getCurrentDailyIncome = function () {
  const uri = '/currentdailyincome'
  return httpFuture.get(uri).map(path([ 'body', 'currentDailyIncome' ]))
}

self.getDailyIncomeHistory = function () {
  const uri = '/dailyincomehistory'
  const query = { sortBy: 'date' }
  return httpFuture.getWithQuery(uri, query).map(path([ 'body', 'dailyIncomeHistory' ]))
}

self.getSubscriptionProducts = function () {
  return httpFuture.get('/subscriptionproducts').map(getSubscriptionProducts)
}

self.getOldSubscriptions = function () {
  return httpFuture.get('/oldsubscriptions').map(getSubscriptions)
}

self.setSubscriptionProductPrice = function (id, prices) {
  const uri = `/subscriptionproducts/${id}/price`
  const data = {
    subscriptionProduct: prices,
  }
  return httpFuture.putWithData(uri, data).map(getSubscriptionProduct)
}

self.createSubscriptionProduct = function (subscriptionProduct) {
  const uri = '/subscriptionproducts'
  const data = { subscriptionProduct }
  return httpFuture.postWithData(uri, data).map(getSubscriptionProduct)
}

self.startSubscription = function (payerId, payerInfo, ownerId) {
  const uri = `/subscriptions/${payerId}/start`
  const data = { payerInfo, ownerId }
  return httpFuture.postWithData(uri, data)
}

self.cancelForOwners = function (payerId, ownerId) {
  const uri = `/subscriptions/${payerId}/cancelforowners`
  const data = { ownerId }
  return httpFuture.postWithData(uri, data)
}

self.setBillingCycle = function (ownerId, billingCycle) {
  const uri = `/subscriptions/${ownerId}/billingcycle`
  const data = { billingCycle }
  return httpFuture.putWithData(uri, data).map(getSubscription)
}

self.setPayerPrice = function (ownerId, productSpec) {
  const uri = `/subscriptions/${ownerId}/price`
  const data = { productSpec }
  return httpFuture.postWithData(uri, data).map(getSubscription)
}

self.setInvoiceData = function (ownerId, invoiceData) {
  const uri = `/subscriptions/${ownerId}/invoicedata`
  const data = { invoiceData }
  return httpFuture.postWithData(uri, data).map(getSubscription)
}

self.convertSubscription = function (ownerId) {
  const uri = `/subscriptions/${ownerId}/converttrial`
  return httpFuture.post(uri)
}

self.setInvoicePayer = function (ownerId, payerId) {
  const uri = `/subscriptions/${ownerId}/invoicepayer`
  const data = { payerId }
  return httpFuture.postWithData(uri, data).map(getSubscription)
}

self.searchSubscription2 = function (query) {
  const q = JSON.stringify(query)
  return httpFuture.getWithQuery('/subscriptions', { q }).map(getSubscriptions)
}

self.setEnterpriseMode = function (ownerId, enterprise) {
  const uri = `/subscriptions/${ownerId}/enterprisemode`
  const data = { subscription: { enterprise } }
  return httpFuture.putWithData(uri, data).map(getSubscription)
}

self.addOneTimeFee = function (ownerId, oneTimeFee) {
  const uri = `/subscriptions/${ownerId}/onetimefees`
  const data = { oneTimeFee }
  return httpFuture.postWithData(uri, data).map(getSubscription)
}

self.updateOneTimeFee = function (ownerId, oneTimeFeeId, oneTimeFee) {
  const uri = `/subscriptions/${ownerId}/onetimefees/${oneTimeFeeId}`
  const data = { oneTimeFee }
  return httpFuture.putWithData(uri, data).map(getSubscription)
}

self.removeOneTimeFee = function (ownerId, oneTimeFeeId) {
  const uri = `/subscriptions/${ownerId}/onetimefees/${oneTimeFeeId}`
  return httpFuture.del(uri).map(getSubscription)
}

self.pushValidUntil = function (ownerId, validUntil) {
  const uri = buildURI([ '/subscriptions', ownerId, 'validUntil' ])
  const data = { validUntil }
  return httpFuture.putWithData(uri, data).map(getSubscription)
}

self.updateSubscriptionCurrency = function (ownerId, currency) {
  const uri = `/subscriptions/${ownerId}/currency`
  const data = { currency }
  return httpFuture.postWithData(uri, data).map(getSubscription)
}

module.exports = self
